import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { useHistory, } from 'react-router-dom';
import { useSelector } from "react-redux";
import { IoClose } from "react-icons/io5";

import styles from './MobileHome.module.css';
import Header from '../../../components/header/Header';
import { Watchlist } from '../../watchlist/Watchlist';
import { Dip } from '../../dip/Dip';
import { Trend } from '../../trend/Trend';
import { selectUser } from '../../login/LoginSlice';
import MobileDashboard from '../dashboard/MobileDashboard';
import MobileBreadCrumb from '../../../components/breadcrumbs/MobileBreadCrumb';
import MobileDip from '../mobileDip/MobileDip';
import MobileHeader from '../mobileHeader/MobileHeader';
import MobileTrend from '../mobileTrend/MobileTrend';
import BottomNavigation from '../BottomNavigation/BottomNavigation';

const MobileHome = () => {
    const history = useHistory();
    const userObject = useSelector(selectUser);
    const [renderDashboard, setRenderDashboard] = useState(true);
    const [activeIndex, setActiveIndex] = useState(null);

    const [showSidebar, setShowSidebar] = useState(false);

    useEffect(() => {
        const currentPath = history.location.pathname;
        if (currentPath === '/home/dip') setActiveIndex(0);
        else if (currentPath === '/home/trend') setActiveIndex(1);
        else setActiveIndex(null);
    }, [history.location.pathname]);

    //Validate session.
    useEffect(() => {
        //if (!(userObject?.isAuthenticated)) history.push('/landing-page');
        const session = localStorage.getItem('userObject');
        if (!session || session === 'undefined' || session === 'null') {
            history.push('/landing-page');
        }
    }, [])

    /**
     * Function to hide the Dashboard and navigate to an individual feature component.
     * Called when a feature tile is clicked.
     * @param {number} index
     */
    const goToIndividualFeature = (index) => {

        setRenderDashboard(false);

        switch (index) {
            case 0: history.push('/home/dip');
                setActiveIndex(index);
                break;
            case 1: history.push('/home/trend');
                setActiveIndex(index);
                break;

            default:
                break;
        }

    }

    const toggleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    const closeSidebar = () => {
        setShowSidebar(false);
    };

    const [showHeader, setShowHeader] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const currentY = window.scrollY;

            if (currentY > lastScrollY && currentY > 80) {
                // scrolling down & passed a small threshold
                setShowHeader(false);
            } else if (currentY < lastScrollY) {
                // scrolling up
                setShowHeader(true);
            }
            setLastScrollY(currentY);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [lastScrollY]);

    return (
        <div className='container-fluid'>
            <div className={`row ${styles.wrapper}`}>
                {/* <Header /> */}

                <div className='col-12'>
                    <div className='row'>
                        <div className={`col-lg-2 col-md-3 col-sm-12 ${styles.sidebar_wrapper}`}>
                            <Watchlist />
                        </div>

                        <div className={`${styles.dashboard_sidebar} ${showSidebar ? styles.active : ''}`}>
                            <div className={styles.close_section}>
                                <span></span>
                                <button onClick={closeSidebar}><IoClose /></button>
                            </div>
                            <div className={styles.dashboard_sidebar_options}>
                                <Watchlist />
                            </div>
                        </div>

                        <div className='col-lg-10 col-md-9 col-sm-12'>
                            <MobileHeader toggleSidebar={toggleSidebar} showSidebar={showSidebar} showHeader={showHeader} />

                            <div className={showHeader ? styles.breadcrumb_section : styles.hide} >
                                {/* <input type='button' className='btn btn-success bi bi-arrow-return-left' value='Back To Dashboard' onClick={() => { setRenderDashboard(true); history.push('/home'); }}></input> */}
                                <MobileBreadCrumb
                                    activeIndex={activeIndex}
                                    onBackToDashboard={() => { history.push('/home'); }}
                                    breadcrumbNavigation={(index) => {
                                        if (index === 0) history.push('/home/dip');
                                        if (index === 1) history.push('/home/trend');
                                    }}
                                    renderDashboard={false}
                                />
                            </div>

                            <Switch>
                                <Route path='/home/dip' component={MobileDip} exact></Route>
                                <Route path='/home/trend' component={MobileTrend} exact></Route>
                            </Switch>

                            <BottomNavigation onBackToDashboard={() => { setRenderDashboard(true); history.push('/home'); }} showHeader={showHeader} />

                        </div>
                    </div>
                </div>



            </div>
        </div>
    )
}

export default MobileHome